import { QSetQuestionDetails } from '@exam-management/qset-question-details';
import { Flex, Text, PaperSection } from '@shared/components';

import { useQSetSimilarityCheckResultDetails } from '../../providers';

export default function QSetSimilarityCheckResultDetails() {
  const { totalDuplicatedQuestions, duplicatedQuestions } = useQSetSimilarityCheckResultDetails();
  return (
    <PaperSection title='Duplicate Questions'>
      <Flex
        sx={(theme) => ({
          p: theme.spacing(6),
          gap: theme.spacing(6),
          flexDirection: 'column',
          '> .MuiPaper-root': {
            '--Paper-shadow': 'none !important',
            border: `1px solid ${theme.palette.grey[300]}`,
            borderRadius: theme.shape.rounded(2),
          },
        })}
      >
        <Text variant='h4'>จำนวนทั้งหมด {totalDuplicatedQuestions} ข้อ</Text>
        {duplicatedQuestions.map((duplicatedQuestion) => {
          const { order, question } = duplicatedQuestion;
          if (!question) return null;
          return (
            <QSetQuestionDetails key={duplicatedQuestion.id} question={question} order={order} />
          );
        })}
      </Flex>
    </PaperSection>
  );
}
